import { render, staticRenderFns } from "./DealerSearch.vue?vue&type=template&id=f72e3482&scoped=true&"
import script from "./DealerSearch.vue?vue&type=script&lang=js&"
export * from "./DealerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e3482",
  null
  
)

export default component.exports